import React from "react";
import styled from "styled-components";
import { Link } from 'react-router-dom'
import { ButtonPropsType } from "./Button.types";

const Component: React.FC<ButtonPropsType> = (props) => {
  return props.linkTo ? <Link {...props} to={props.linkTo}>{props.children}</Link> : <button {...props}>{props.children}</button>
};

export const Button = styled(Component)`
  align-items: center;
  border-radius: 6px;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  font-size: 16px;
  font-weight: bold;
  justify-content: center;
  padding: 12px 0;
  transition: background 0.2s, border 0.2s;
  width: 100%;

  background: ${(props) => (props.invert ? "#fff" : props.color)};
  border: 1px solid ${(props) => (props.invert ? props.color : "#fff")};
  color: ${(props) => (props.invert ? props.color : "#fff")};

  &:hover {
    background: ${(props) => (props.invert ? props.color : "#fff")};
    border: 1px solid ${(props) => (props.invert ? "#fff" : props.color)};
    color: ${(props) => (props.invert ? "#fff" : props.color)};
  }

  &:focus {
    outline: 1px solid ${(props) => (props.invert ? "#fff" : props.color)};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
